import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Impressum() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page" data-testid="impressum-page">
      <div className="legal-container">
        <Link to="/" className="legal-back" data-testid="impressum-back-link">
          <ArrowLeft strokeWidth={1.5} size={18} /> Zurück zur Startseite
        </Link>

        <h1 className="legal-title">Impressum</h1>

        <div className="legal-content">
          <div className="legal-address-block">
            <p><strong>Vanessa Würzler</strong></p>
            <p>Sophienstraße 77<br />64711 Erbach</p>
          </div>

          <div className="legal-address-block">
            <p><strong>Kontakt:</strong></p>
            <p>Tel.: 0171 2956132<br />E-Mail: vanessa@mitgefuehl.live<br />Website: www.mitgefuehl.live</p>
          </div>

          <div className="legal-address-block">
            <p><strong>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</strong></p>
            <p>Nicht vorhanden</p>
          </div>

          <p>Umsatzsteuer führen wir als Kleinunternehmer nach § 19 UStG nicht ab.</p>
        </div>
      </div>
    </div>
  );
}
